import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import classNames from "classnames";
import { Loading } from "@jti/ui/components/Loading";
import "./style.scss";
export const LoadingLayer = ({ isVisible, testId, transparentBackground = true }) => {
    const BODY_LOCKED_CLASS = "body-locked";
    useEffect(() => {
        const element = window.document.querySelector("body");
        if (element) {
            isVisible ? element.classList.add(BODY_LOCKED_CLASS) : element.classList.remove(BODY_LOCKED_CLASS);
        }
    }, [isVisible]);
    if (!isVisible) {
        return null;
    }
    const className = classNames("loading-layer", {
        "loading-layer--white": !transparentBackground,
    });
    return (_jsxs("div", { className: className, "data-testid": testId, children: [_jsx("div", { className: "loading-layer__backdrop" }), _jsx("div", { className: "loading-layer__content", children: _jsx(Loading, {}) })] }));
};
//# sourceMappingURL=LoadingLayer.js.map